
/*const dev = {
    API_ROOT: 'https://backend.amygbdemos.in/api',
    WS_ROOT: 'https://backend.amygbdemos.in/',
    VISION_ROOT: 'https://idpmigratedstaging.amygbdemos.in/api',
}*/

const dev = {
    API_ROOT: 'https://backend.amygbdemos.in/api',
    WS_ROOT: 'https://backend.amygbdemos.in/',
    VISION_ROOT: 'https://idpdemostagingbackend.amygbdemos.in/api',
}


export default dev;